module.exports = __webpack_public_path__ + "img/Outgoing Job Completed.0acde618.png";